import { render } from "./BandActiveSignals.vue?vue&type=template&id=61d65b7c&scoped=true"
import script from "./BandActiveSignals.vue?vue&type=script&lang=js"
export * from "./BandActiveSignals.vue?vue&type=script&lang=js"

import "./BandActiveSignals.vue?vue&type=style&index=0&id=61d65b7c&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d65b7c"]])

export default __exports__